<template>
    <main>
        <div class="common-report consulatnt-workload-view">
            <ConsultantworkloadRelation/>
            <ConsultantworkloadAllocation/>
        </div>
    </main>
</template>

<script>
    const ConsultantworkloadRelation = () => import("./consultant-workload/ConsultantworkloadRelation");
    const ConsultantworkloadAllocation = () => import("./consultant-workload/ConsultantworkloadAllocation");

    export default {
        name: "Consultantworkload",
        components: {ConsultantworkloadAllocation, ConsultantworkloadRelation},
        computed: {
            filter: function () {
                return this.$store.state.reports.consultantWorkloadFilter;
            }
        },
        beforeMount() {
            this.fetchData();
        },
        methods: {
            fetchData: function () {
                this.$store.dispatch("fetchConsultantWorkload", this.filter);
                this.$store.dispatch("fetchConsultantWorkloadAggregate", this.filter);
            }
        }
    };
</script>

<style scoped>
</style>